import { render, staticRenderFns } from "./fit.vue?vue&type=template&id=0729688a&scoped=true"
import script from "./fit.vue?vue&type=script&lang=js"
export * from "./fit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0729688a",
  null
  
)

export default component.exports